import { render, staticRenderFns } from "./MARSQuestionnairePanels.vue?vue&type=template&id=15caa80e&"
import script from "./MARSQuestionnairePanels.vue?vue&type=script&lang=js&"
export * from "./MARSQuestionnairePanels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports